module.exports = __webpack_public_path__ + "static/media/table_download_icon.274cf77f.svg";